<script>
    import { writable } from "svelte/store";
    import { navigate } from "../router";
    import { getUser } from "../user.js";
    import { onMount } from "svelte";
    import { load as loadTeam, create as createTeam, update as updateTeam } from "../teams.js";
    import { load as loadGame, create as createGame, update as upadteGame } from "../games.js";

    import { Background, Font, Padding } from "../component/modifier";
    import { DStack, HStack, VStack, Spacer } from "../component/layout";
    import CookieConsent from "../component/CookieConsent.svelte";
    import Header from "../component/Header.svelte";
    import Copyright from "../component/Copyright.svelte";
    import GameCell from "../component/GameCell.svelte";
    import TeamCell from "../component/TeamCell.svelte";
    import {
        Button,
        Label,
        Text,
        Choice,
        DateField,
        TimeField,
        Upload,
    } from "../component/widget";
    import { info } from "../wedding.js";
    import { GAME_TYPE, GAME_MODE, GAME_PROGRESS_MODE } from "../dico.js";

    export let wedding_guid;
    export let tab;

    let isTeamView = true;
    let isGameView = false;
    let isAddTeam = false;
    let isAddGame = false;

    let current = "";

    let showError = false;
    let errorMessage = null;

    let teams = [];
    let games = [];

    let name = null;
    let type = "QCM";
    let mode = "T";
    let progess_mode = "SYNC";
    let penalty = 0;
    let duration = null;
    let startDate = new Date();
    let startTime = null;
    let dateChosen = null;
    let selectedDateFormatted = null;
    let desc = null;
    let image = null;
    let created_id = null;
    let gameId = null;
    let teamId = null;

    function updateTab(tab) {
        isTeamView = tab === "T";
        isGameView = tab === "G";
    }

    $: updateTab(tab);

    function showTeamView() {
        navigate(`#/quizz/${wedding_guid}/T`);
    }

    function showGameView() {
        navigate(`#/quizz/${wedding_guid}/G`);
    }

    const submitTeam = async () => {
        try {
            if (teamId) {
                await updateTeam(wedding_guid, teamId, name);
            } else {
                let r = await createTeam(wedding_guid, name);
                created_id = r.data.id;
            }

            refresh();
            reset();
        } catch (e) {
            showError = true;
            errorMessage = e;
        }
    };

    const submitGame = async () => {
        try {
            let start = startDate;
            start.setHours(startTime.getHours());
            start.setMinutes(startTime.getMinutes());
            start.setSeconds(startTime.getSeconds());
            let timestamp = Math.round(start.getTime() / 1000);
            let r = await createGame(
                wedding_guid,
                name,
                type,
                desc,
                duration,
                timestamp,
                mode,
                image
            );
            created_id = r.data.id;

            refresh();
            reset();
        } catch (e) {
            showError = true;
            errorMessage = e;
        }
    };

    const cancel = () => {
        isAddTeam = false;
        isAddGame = false;
    };

    const handle_cancel = () => {
        reset();
        cancel();
    };

    const reset = () => {
        name = null;
        type = "QCM";
        desc = null;
        startDate = new Date();
        startTime = null;
    };

    const validate = (event) => {
        switch (event.target.name) {
            default:
                break;
        }
    };

    //$: console.log(games);
    //$: console.log(teams);

    const refresh = async () => {
        try {
            isAddTeam = false;
            isAddGame = false;

            loadTeam(wedding_guid)
                .then((r) => {
                    teams = r;
                })
                .catch((e) => {
                    console.log(e);
                    teams = [];
                });

            loadGame(wedding_guid, false)
                .then((r) => {
                    r.forEach((i) => {
                        i.isOpened = created_id === i.id;
                    });
                    games = r;
                })
                .catch((e) => {
                    console.log(e);
                    games = [];
                });
        } catch (e) {
            console.log(e);
        }
    };

    let wedding = writable(undefined);

    let userRequest;

    onMount(() => {
        console.log("Quizz on mount");

        userRequest = getUser();

        const unsubscribe = userRequest.subscribe((promise) => {
            promise.then((u) => {
                info(wedding_guid, true)
                    .then((r) => {
                        wedding.set(r.data);
                    })
                    .then(() => refresh())
                    .catch((e) => {
                        wedding.set(undefined);
                        navigate("/");
                    });
            });
        });

        return () => {
            console.log("Quizz destroy");
            unsubscribe();
        };
    });
</script>

<main>
    <CookieConsent />
    <Header>
        <div slot="left">
            <Button action={() => navigate(`#/dashboard/${wedding_guid}`)}>
                <Label text="Dashboard" icon="tachometer-alt" borderLeft h="48px" />
            </Button>
        </div>
    </Header>
    <Background color="white">
        <DStack query="(min-width: 481px)" alignment="stretch" overflow="auto">
            <!-- <HStack grow alignment="stretch"> -->
            <div class="menu">
                <VStack alignment="stretch">
                    <Background color="var(--primary-dark-color)">
                        <Padding>
                            <Font name="Cinzel" size="1.5em">
                                <Label
                                    text="Champiz"
                                    iconSize="48"
                                    icon="images/champignon.svg"
                                    fa={false}
                                    color="var(--secondary-light-color)"
                                    h="48px" />
                            </Font>
                        </Padding>
                    </Background>
                    <DStack query="(max-width: 480px)">
                        <Spacer minSpacing="10px" />
                        <Padding>
                            <Button selected={isGameView} action={showGameView}>
                                <Label text="Jeux" icon="puzzle-piece" size="28" />
                            </Button>
                        </Padding>
                        <Spacer minSpacing="10px" />
                        <Padding>
                            <Button selected={isTeamView} action={showTeamView}>
                                <Label text="Equipes" icon="users" size="28" />
                            </Button>
                        </Padding>
                        <Spacer minSpacing="10px" />
                    </DStack>
                    <Spacer minSpacing="10px" />
                </VStack>
            </div>
            <article>
                {#if isTeamView}
                    <h2>Equipes</h2>
                    {#if isAddTeam}
                        {#if showError}
                            <div class="error">Une erreur s'est produite: {errorMessage}</div>
                        {/if}
                        <form
                            on:submit|preventDefault={submitTeam}
                            on:invalid={validate}
                            on:changed={validate}
                            on:input={validate}>
                            <Text
                                id={"name"}
                                reset
                                required
                                bind:value={name}
                                icon="fas fa-users"
                                label="Nom"
                                placeholder="Nom de l'équipe"
                                bind:current />

                            <HStack>
                                <button class="cancel" type="button" on:click={handle_cancel}>
                                    <i class="fas fa-angle-double-up" />
                                    <span>Annuler</span>
                                </button>
                                <button class="primary" type="submit">
                                    <i class="fas fa-user-plus" />
                                    {#if teamId}
                                        <span>Modifier</span>
                                    {:else}
                                        <span>Ajouter</span>
                                    {/if}
                                </button>
                                <Spacer />
                            </HStack>
                        </form>
                    {:else}
                        <div class="actions">
                            <Button action={() => (isAddTeam = true)}>
                                <Label
                                    text="Ajouter une équipe"
                                    noshrink
                                    icon="user-plus"
                                    h="2em" />
                            </Button>
                        </div>
                    {/if}

                    {#each teams as t, i (t.id)}
                        <TeamCell
                            {wedding_guid}
                            team={t}
                            code={$wedding ? $wedding.code : null}
                            bind:isOpened={t.isOpened}
                            on:refresh={refresh} />
                    {/each}
                {:else if isGameView}
                    <h2>Jeux</h2>

                    {#if isAddGame}
                        {#if showError}
                            <div class="error">Une erreur s'est produite: {errorMessage}</div>
                        {/if}
                        <form
                            on:submit|preventDefault={submitGame}
                            on:invalid={validate}
                            on:changed={validate}
                            on:input={validate}>
                            <Text
                                id={"name"}
                                reset
                                required
                                bind:value={name}
                                icon="fas fa-puzzle-piece"
                                label="Nom"
                                placeholder="Titre du jeu"
                                bind:current
                                textTransform={"capitalize"} />

                            <Choice
                                id={"type"}
                                label="Type"
                                bind:value={type}
                                bind:current
                                icon="fas fa-chess"
                                values={GAME_TYPE} />

                            <Choice
                                id={"mode"}
                                label="mode"
                                bind:value={mode}
                                bind:current
                                icon="fas fa-users"
                                values={GAME_MODE} />

                            <Choice
                                id={"progess_mode"}
                                label="progess_mode"
                                bind:value={progess_mode}
                                bind:current
                                icon="fas fa-sync"
                                values={GAME_PROGRESS_MODE} />

                            <DateField
                                id={"startDate"}
                                required
                                placeholder="Choisissez une date de début"
                                bind:selectedDateFormatted
                                bind:value={dateChosen}
                                bind:selectedDate={startDate}
                                label="Date"
                                bind:current />

                            <TimeField
                                id={"startTime"}
                                required
                                bind:value={startTime}
                                label="Heure"
                                placeholder="Choisissez une heure de début"
                                bind:current />

                            <Text
                                id={"duration"}
                                type="number"
                                reset
                                bind:value={duration}
                                icon="fas fa-user-clock"
                                label="Durée"
                                placeholder="Durée du jeu (en secondes)"
                                bind:current />

                            <Text
                                id={"penalty"}
                                type="number"
                                required
                                reset
                                bind:value={penalty}
                                icon="fas fa-history"
                                label="Pénalité"
                                placeholder="Pénalité (en secondes)"
                                bind:current />

                            <Upload
                                id="image"
                                reset
                                type="image"
                                height="64"
                                bind:value={image}
                                icon="fas fa-picture"
                                placeholder="Choissisez une image"
                                bind:current />

                            <HStack>
                                <button class="cancel" type="button" on:click={handle_cancel}>
                                    <i class="fas fa-angle-double-up" />
                                    <span>Annuler</span>
                                </button>
                                <button class="primary" type="submit">
                                    <i class="fas fa-user-plus" />
                                    {#if gameId}
                                        <span>Modifier</span>
                                    {:else}
                                        <span>Ajouter</span>
                                    {/if}
                                </button>
                                <Spacer />
                            </HStack>
                        </form>
                    {:else}
                        <div class="actions">
                            <Button action={() => (isAddGame = true)}>
                                <Label text="Ajouter un jeu" noshrink icon="user-plus" h="2em" />
                            </Button>
                        </div>
                    {/if}

                    {#each games as g, i (g.id)}
                        <GameCell
                            {wedding_guid}
                            game={g}
                            bind:isOpened={g.isOpened}
                            on:refresh={refresh} />
                    {/each}
                {/if}
            </article>
        </DStack>
        <!-- </HStack> -->
    </Background>
    <Copyright company="KiwisApp" />
</main>

<style>
    main {
        overflow-x: auto;
    }

    article {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
        flex: 1 1 auto;
        margin-left: 1em;
        margin-right: 1em;
        margin-bottom: 5em;
    }

    form {
        width: 100%;
    }

    .menu {
        background-color: var(--primary-color);
        color: var(--on-primary-color);
        width: 100%;
    }

    @media screen and (min-width: 481px) {
        .menu {
            width: 225px;
        }
        form {
            min-width: 480px;
        }
    }

    div.actions {
        margin-top: 5px;
        margin-bottom: 5px;
        padding-top: 0.5em;
        padding-bottom: 0.5em;
        border-radius: 5px;
    }

    .actions:hover {
        background-color: rgb(235, 236, 240);
    }

    div.error {
        color: var(--error-color);
        background-color: white;
        display: block;
        font-size: 12px;
        margin: auto;
        padding: 1em;
    }
</style>
